import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const StyledDialog = withStyles(() => ({
  paper: {
    margin: 18,
  },
  paperWidthSm: {
    width: '100%',
    maxWidth: 588,
  },
  paperScrollPaper: {
    flexDirection: 'row',
  },
}))(Dialog);

export const Content = styled.section`
    position: relative;
    width: 100%;
    height: 139px;
    padding: 32px 58px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    h2 {
        color: ${COLOR.BLUE_1};
        position: relative;
        text-transform: initial;

        font-family: Barlow;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #464D5C;
    }

    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      padding: 32px 48px;
      h2 {
        font-size: 20px;
      }
    }

    /* Desktop */
    @media screen and (min-width: ${BREAKPOINT.LG}) {
      h2 {
        font-size: 22px;
      }
    }
`;

export const BoxButtons = styled.section`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
`;
